export const phone = /^(62)8[1-9]\d{6,10}$/;
export const number = /^\d+$/;
